import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const BarcodeFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function BarcodeFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M5 6H3v12h2v3H0V3h5v3ZM24 21h-5v-3h2V6h-2V3h5v18ZM8.007 16h-3V8h3v8ZM13.507 16h-3V8h3v8Z" />
          <path d="M19.007 16h-3V8h3v8Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default BarcodeFilled;